<!-- Content -->
<!-- Agent Counter widget shouldn't show the no data error and instead should just show the zero data -->
<!-- <app-module-error [noData]="true" *ngIf="noData"></app-module-error> -->
<!-- height and width 278 px and cutout percent 80 gives chart ring 24 px at their size of doughnut chart -->
<div class="w-100 h-100"> 
    <canvas *ngIf="chartConfig" 
        baseChart
        width="400px"
        height="225px"
        [type]="chartConfig.type"
        [legend]="chartConfig.options.plugins.legend"
        [datasets]="chartConfig.data.datasets"
        [labels]="chartConfig.data.labels"
        [options]="chartConfig.options"
        [plugins]="chartConfig.plugins">
    </canvas>
</div>
